import { useMemo } from "react"
import { MarketsType, RegionType } from "../types"
import { queryCache, useQuery } from "react-query"
import { fetchLookUp } from "../api"
import { useRevenueParams } from "./useRevenueParams"

export function useMarketsWithRegions() {
  const { search } = useRevenueParams()
  const cached = queryCache.getQueryData("lookup")

  const { data } = useQuery("lookup", fetchLookUp, {
    enabled: !search || !cached,
  })

  const marketsWithRegions = useMemo(() => {
    let markets: MarketsType[] = []
    data?.regions?.forEach((region: RegionType) => {
      region?.markets?.forEach((market: MarketsType) => {
        if (market?.name !== "All") {
          market.region = region.name
          markets?.push(market)
        }
      })
    })
    return markets
  }, [data?.regions])

  return {
    marketsWithRegions,
  }
}
